import { atom } from 'recoil';

export const isRightSideModalOpenState = atom({
  key: 'rightSideModalState',
  default: false,
});
